import { dev } from '$app/environment';

export const LINKS = {
	medium: 'https://juslin.medium.com/',
	facebook: 'https://www.facebook.com/Juslin.Komenan/',
	github: 'https://github.com/juslin03',
	linkedin: 'https://www.linkedin.com/in/juslin/',
	twitter: 'https://x.com/misterjuslin',
	whatsapp:
		'https://api.whatsapp.com/send/?phone=2250759842878&text&type=phone_number&app_absent=0',
	whatsapp_link:
		'https://api.whatsapp.com/send/?phone=2250759842878?text=Bonjour%20Juslin%2C%0Aj%27ai%20consult%C3%A9%20votre%20portfolio%20JUSLIN.DEV.%0AJe%20suis%20int%C3%A9ress%C3%A9%20par%20vos%20services%20d%27ing%C3%A9nierie%20et%20de%20d%C3%A9veloppement%20pour%20un%20nouveau%20projet.%0A%0AMerci%20de%20me%20revenir%20%21'
};

export const SITE_URL = dev ? 'http://localhost:5173' : 'https://www.juslin.dev';
export const SITE_ASSETS_URL = `https://cdn.juslin.dev`;

export type SocialLinkType = keyof typeof LINKS;
